import type { Role } from '../../../core/policy/roles';

/**
 * What each role means, in the words the committee uses.
 *
 * Named by what the holder may do rather than by the identifier: "committee_hr"
 * tells a manager nothing about whether that person will be able to approve a
 * waiting registration.
 */
export const ROLE_LABELS_AR: Readonly<
  Record<Role, { readonly name: string; readonly what: string }>
> = {
  committee_manager: {
    name: 'مدير اللجنة',
    what: 'كل ما سبق، وضبط المراحل، ومنح الصلاحيات',
  },
  committee_hr: {
    name: 'الموارد البشرية',
    what: 'اعتماد طلبات التسجيل وتصحيح سجلات الموظفين',
  },
  committee_finance: {
    name: 'المالية',
    what: 'الاطلاع على البيانات الإدارية دون التقارير الطبية',
  },
  employee: {
    name: 'موظف',
    what: 'بياناته ومعاليه ووثائقه وحدها',
  },
};

export type { Role };
